<template>
    <div>
        <avue-crud :data="data" :option="option" :search.sync="search" @selection-change="selectionChange"
                   @size-change="sizeChange" :page.sync="page" @current-change="currentChange"
                   @search-change="searchChange" @search-reset="resetChange">
            <template slot="menuLeft" slot-scope="scope">
                <el-button class="customize" @click="applicantBtn" v-if="user_type.user_type!==1">上传申请人身份证明</el-button>
                <el-button class="customize" @click="initiate">发起立案</el-button>
                <el-button class="customize" @click="batch">批量导入案件</el-button>
                <el-button class="customize" @click="submitBtn">批量提交给代理人</el-button>
                <el-button class="customize" @click="relationBtn" v-if="userData.platform_sn != 2">关联证据清单</el-button>
                <el-button class="customize" @click="correlationBtn" v-if="userData.platform_sn != 2">关联补充证据清单</el-button>
            </template>
            <template slot="index" slot-scope="scope">
                {{page.total - ((page.currentPage - 1) * page.pageSize + scope.row.$index)}}
            </template>
            <!--            <template slot="tip" slot-scope="scope" >-->
            <!--                <el-button type="text" class="batch" @click="submitBtn">批量提交</el-button>-->
            <!--            </template>-->
            <!--            操作栏按钮-->
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="progress(scope.row)">查看进度</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="dealWith(scope.row)">案件详情</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="replenish(scope.row)" v-if="userData.platform_sn != 2">证据材料</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="supplement(scope.row)" v-if="userData.platform_sn != 2">补充证据</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="cancelBtn(scope.row)" v-if="scope.row.status==0">
                    删除案件
                </el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="modifyBtn(scope.row)">修改立案信息</el-dropdown-item>
                <!-- <el-dropdown-item class="pull-down" @click.native="viewMaterialBtn(scope.row)">查看保险材料和文书
                </el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="transferBtn(scope.row)">转入投保案件</el-dropdown-item> -->
                <!--                <el-button  v-if="scope.row.is_has_msg==1&&scope.row.user_read==0" class="customize" @click="check(scope.row)">查看留言</el-button>-->
                <!--                <el-button  v-else-if="scope.row.user_read==1"  class="remarks" @click="check(scope.row)">查看留言</el-button>-->
                <!--                <el-button class="customize" @click="message(scope.row)">给代理人留言</el-button>-->
            </template>
            <template slot="status" slot-scope="scope">
                <div v-if="scope.row.bohui_liyou">
                    <el-tooltip class="item" effect="dark" :content="'驳回理由：'+scope.row.bohui_liyou" placement="top">
                        <span>{{scope.row.status_txt}}</span>
                    </el-tooltip>
                </div>
                <div v-else>
                    <span>{{scope.row.status_txt}}</span>
                </div>
            </template>
            <template slot="case_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.case_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.case_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="zhcai_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.zhcai_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.zhcai_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="product_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.product_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.product_name }}</p>
                </el-tooltip>
            </template>
            <template slot="signers_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signers_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signers_txt }}</p>
                </el-tooltip>
            </template>
            <template slot="tijiao_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.tijiao_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.tijiao_time }}</p>
                </el-tooltip>
            </template>
            <template slot="lian_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.lian_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.lian_time }}</p>
                </el-tooltip>
            </template>
            <template slot="jie_an_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.jie_an_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.jie_an_time }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        留言-->
        <el-dialog
                title="留言"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <el-form :model="form">
                <el-form-item label="给代理人留言" :label-width="formLabelWidth">
                    <el-input v-model="form.content" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="determine">确 定</el-button>
                </span>
        </el-dialog>
        <!--        查看进度-->
        <el-dialog
                title="查看进度"
                :visible.sync="caseProgress"
                :close-on-click-modal="false"
                width="50%">
            <div class="schedule">
                <el-timeline>
                    <el-timeline-item
                            v-for="(activity, index) in activities"
                            :key="index"
                            :icon="activity.icon"
                            :type="activity.type"
                            :color="activity.color"
                            :size="activity.size"
                            :timestamp="activity.timestamp">
                        {{activity.content}}
                    </el-timeline-item>
                </el-timeline>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="caseProgress = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--    关联补充证据清单    -->
        <el-dialog
                title="关联补充证据清单"
                :visible.sync="correlation"
                :close-on-click-modal="false"
                width="60%">
            <div class="relation">
                <avue-crud :data="listData" :option="option1">
                    <template slot-scope="scope" slot="menu">
                        <el-button class="customize" @click="bindBtn(scope.row)">绑定</el-button>
                    </template>
                </avue-crud>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="correlation = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--        关联证据清单-->
        <el-dialog
                title="关联证据清单"
                :visible.sync="relation"
                :close-on-click-modal="false"
                width="60%">
            <div class="relation">
                <avue-crud :data="inventoryData" :option="option2">
                    <template slot-scope="scope" slot="menu">
                        <el-button class="customize" @click="bindListBtn(scope.row)">绑定</el-button>
                    </template>
                </avue-crud>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="relation = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!--        删除案件-->
        <el-dialog
                title="删除案件"
                :visible.sync="revokeCase"
                :close-on-click-modal="false"
                width="30%">
            <span>请确认是否要删除该案件</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="revokeCase = false">取 消</el-button>
                <el-button type="primary" @click="revokeCaseBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        arbitrationList,
        cancelCase,
        caseSearch,
        checkProgress,
        leaveMessage,
        submitCase
    } from '../../../api/arbitrationCase';
    import { associatedList, associationList, bindEvidenceList, bindingList } from '../../../api/contract';
    import { transferInsure } from '../../../api/insure';

    export default {
        inject: ['reload'], // 引入方法
        name: 'myCase',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 20
                },
                userData:'',
                pages: 1,
                user_type: '',
                relation: false,     //关联证据清单弹框
                caseProgress: false,  //案件进度
                dialogVisible: false,  //给代理人留言
                correlation: false, //关联补充证据
                revokeCase: false, //删除案件
                cancelId: '',
                //进度
                activities: [],
                form: {
                    content: ''
                },
                search: {
                    doc_title: '',
                    signers_txt: '',
                    lawyer_name: '',
                    status: ''
                },
                formLabelWidth: '100px',
                arbitrationId: '',
                data: [],
                listData: [],  //关联清单数据
                inventoryData: [],  //证据清单
                caseList: [],
                importData: [],  //批量提交id
                doc_title: '',  //合同名称
                signers_txt: '', //被申请人
                lawyer_name: '', //代理人
                status: '',  //案件状态
                option: {
                    menuType: 'menu',
                    menuBtnTitle: '操作',
                    // index:true,
                    selection: true, //批量选择
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 150,  //操作栏宽度设置
                    column: [
                        {
                            label: '序号',
                            prop: 'index'
                        },
                        {
                            label: '案件编号',
                            prop: 'case_sn'
                        },
                        {
                            label: '仲裁方式',
                            prop: 'zhcai_type'
                        },
                        {
                            label: '仲裁案号',
                            prop: 'zhcai_sn'
                        },
                        {
                            label: '提交人',
                            prop: 'tijiao_ren'
                        },
                        {
                            label: '合同名称',
                            prop: 'doc_title',
                            search: true
                        }, {
                            label: '合同编号',
                            prop: 'contract_sn'
                        }, {
                            label: '合同类型',
                            prop: 'product_name'
                        }, {
                            label: '被申请人',
                            prop: 'signers_txt',
                            search: true
                        }, {
                            label: '代理人',
                            prop: 'lawyer_name',
                            search: true
                        }, {
                            label: '案件状态',
                            prop: 'status',
                            search: true,
                            type: 'select',
                            dicData: [
                                {
                                    label: '全部',
                                    value: -1
                                },
                                {
                                    label: '待提交',
                                    value: 0
                                },
                                {
                                    label: '待代理人审核',
                                    value: 1
                                },
                                {
                                    label: '待立案审核',
                                    value: 2
                                },
                                {
                                    label: '立案驳回',
                                    value: 3
                                },
                                {
                                    label: '待缴费',
                                    value: 4
                                },
                                {
                                    label: '答辩期',
                                    value: 5
                                },
                                {
                                    label: '审理期',
                                    value: 6
                                },
                                {
                                    label: '裁决期',
                                    value: 7
                                },
                                {
                                    label: '已结案',
                                    value: 8
                                },
                                {
                                    label: '案件转线下',
                                    value: 9
                                },
                                {
                                    label: '和解中',
                                    value: 10
                                },
                                {
                                    label: '案件中止',
                                    value: 11
                                },
                                {
                                    label: '已撤案',
                                    value: 12
                                }

                            ]
                        }, {
                            label: '提交案件时间',
                            prop: 'tijiao_time'
                        }, {
                            label: '立案时间',
                            prop: 'lian_time'
                        }, {
                            label: '结案时间',
                            prop: 'jie_an_time'
                        }
                    ]
                },
                option1: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 300,  //操作栏宽度设置
                    column: [
                        {
                            label: '补充证据清单id',
                            prop: 'id'
                        },
                        {
                            label: '补充证据清单名称',
                            prop: 'name'
                        }
                    ]
                },
                option2: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 300,  //操作栏宽度设置
                    column: [
                        {
                            label: '证据清单id',
                            prop: 'id'
                        },
                        {
                            label: '证据清单名称',
                            prop: 'name'
                        }
                    ]
                }
            };
        },
        methods: {
            //批量操作
            selectionChange(list) {
                this.ids = [];
                list.forEach(res => {
                    this.ids.push(res.id);
                });
            },
            dealWith(row) {
                this.$router.push({ path: '/dealWith', query: { id: row.id } });
            },
            //分页
            currentChange(num) {
                if (this.doc_title == '' && this.signers_txt == '' && this.lawyer_name == '' && this.status == '') {
                    arbitrationList(0, this.page.pageSize, num).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('myCasePage', num);
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                        }
                    });
                } else {
                    //    搜索后分页
                    caseSearch(this.doc_title, this.signers_txt, this.lawyer_name, this.status, 0, this.page.pageSize, num).then(res => {
                        sessionStorage.setItem('myCasePageSearch', num);
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                    });
                }
            },
            //搜索
            searchChange(params, done) {
                caseSearch(params.doc_title, params.signers_txt, params.lawyer_name, params.status, 0, this.page.pageSize, 1).then(res => {
                    this.doc_title = params.doc_title;
                    this.signers_txt = params.signers_txt;
                    this.lawyer_name = params.lawyer_name;
                    this.status = params.status;
                    if (res.code == 200) {
                        sessionStorage.setItem('myCasePageSearch', 1);
                        sessionStorage.setItem('myCasePageParams', JSON.stringify(params));
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
                done();
            },
            //重置搜索
            resetChange() {
                this.doc_title = '';
                this.signers_txt = '';
                this.lawyer_name = '';
                this.status = '';
                arbitrationList(0, this.page.pageSize, this.pages).then(res => {
                    if (res.code == 200) {
                        sessionStorage.removeItem('myCasePage');
                        sessionStorage.removeItem('myCasePageSearch');
                        sessionStorage.removeItem('myCasePageParams');
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                        this.$message.success('重置成功');
                    }
                });
            },
            //发起立案
            initiate() {
                this.$router.push('/initiate');
            },
            //补充证据
            replenish(row) {
                this.$router.push({ path: '/testimony', query: { id: row.id } });
            },
            //批量导入
            batch() {
                this.$router.push('/batchImport');
            },
            //批量提交
            submitBtn() {
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要提交的文件');
                    return;
                }
                submitCase(this.ids).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.reload();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //给代理人留言
            message(row) {
                this.dialogVisible = true;
                this.arbitrationId = row.id;
            },
            //取消
            cancel() {
                this.form.content = '';
                this.dialogVisible = false;
            },
            //确定
            determine() {
                leaveMessage(this.arbitrationId, this.form.content).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.form.content = '';
                        this.dialogVisible = false;
                    } else {
                        this.$message.error(res.msg);
                        this.form.content = '';
                        this.dialogVisible = false;
                    }
                });
            },
            //查看留言
            check(row) {
                this.$router.push({ path: '/checkMessage', query: { id: row.id } });
            },
            //切换每一页的数量
            sizeChange(val) {
                this.page.pageSize = val;
                arbitrationList(0, val, 1).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    }
                });
            },
            progress(row) {
                this.caseProgress = true;
                checkProgress(row.id).then(res => {
                    if (res.code == 200) {
                        this.activities = res.data;
                    }
                });
            },
            //补充证据
            supplement(row) {
                this.$router.push({ path: 'replenish', query: { id: row.id } });
            },
            //关联补充证据
            correlationBtn() {
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要关联的案件');
                    return;
                } else {
                    associationList().then(res => {
                        if (res.code == 200) {
                            this.correlation = true;
                            this.listData = res.data.list;
                        }
                    });
                }
            },
            //绑定补充证据
            bindBtn(row) {
                bindingList(this.ids, row.id).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.reload();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //关联证据清单
            relationBtn() {
                if (this.ids == undefined || this.ids == '') {
                    this.$message.error('请选择要关联的案件');
                    return;
                } else {
                    associatedList().then(res => {
                        this.relation = true;
                        this.inventoryData = res.data.list;
                    });
                }
            },
            //绑定证据清单
            bindListBtn(row) {
                bindEvidenceList(this.ids, row.id).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.reload();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //申请人证据信息
            applicantBtn() {
                this.$router.push({ path: '/applicantPage' });
            },
            //删除
            cancelBtn(row) {
                this.revokeCase = true;
                this.cancelId = row.id;
            },
            //确认删除案件
            revokeCaseBtn() {
                cancelCase(this.cancelId).then(res => {
                    if (res.code == 200) {
                        this.revokeCase = false;
                        this.$message.success(res.msg);
                        this.reload();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            modifyBtn(row) {
                this.$router.push({ path: '/filingInformation', query: { id: row.id } });
            },
            //查看保险材料和文书
            viewMaterialBtn(row) {
                this.$router.push({ path: '/insuranceFile', query: { id: row.id } });
            },
            //转入投保案件
            transferBtn(row) {
                this.$confirm('是否将该案件转入投保案件 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    transferInsure({ case_id: row.id }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {

                });

            }
        },
        created() {
            this.userData = JSON.parse(localStorage.getItem('userData'));
            if (sessionStorage.getItem('myCasePageSearch')) {
                let myCaseParams = JSON.parse(sessionStorage.getItem('myCasePageParams'));
                this.search = myCaseParams;
                this.doc_title = myCaseParams.doc_title;
                this.signers_txt = myCaseParams.signers_txt;
                this.lawyer_name = myCaseParams.lawyer_name;
                this.status = myCaseParams.status;
                caseSearch(this.doc_title, this.signers_txt, this.lawyer_name, this.status, 0, this.page.pageSize, sessionStorage.getItem('myCasePageSearch')).then(res => {
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = sessionStorage.getItem('myCasePageSearch');
                });
            } else {
                if (sessionStorage.getItem('myCasePage') === null) {
                    arbitrationList(0, this.page.pageSize, this.pages).then(res => {
                        if (res.code == 200) {
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                            this.page.currentPage = 1;
                        }
                    });
                } else {
                    arbitrationList(0, this.page.pageSize, sessionStorage.getItem('myCasePage')).then(res => {
                        if (res.code == 200) {
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                            this.page.currentPage = sessionStorage.getItem('myCasePage');
                        }
                    });
                }
            }


            this.user_type = JSON.parse(sessionStorage.getItem('shenfen'));
        }
    };
</script>

<style scoped>
    .customize {
        background-color: #1d63f5;
        color: #fff;
    }

    /deep/ .el-table__fixed-right {
        height: 100% !important;
    }

    /deep/ .avue-crud__tip {
        height: 40px;
    }

    .batch {
        color: #1d63f5;
        font-size: 14px;
        width: 80px;
    }

    .remarks {
        background-color: #ff1010;
        color: #fff;
    }


    /deep/ .el-timeline {
        width: 50%;
        margin: auto;
    }

    .schedule {
        height: 400px;
        overflow: auto;
    }

    .relation {
        height: 250px;
        overflow: auto;
    }

    /deep/ .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    /deep/ .el-icon-arrow-down {
        font-size: 15px;
    }

    .pull-down {
        padding: 5px 30px !important;
    }
    /deep/ .avue-form__row{
        width: 20%;
    }
    /deep/ .avue-form__menu{
        width: 200px;
    }
    /deep/ .avue-form__group{
        align-items: flex-end;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
